import Paper from "@material-ui/core/Paper";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import InfoIcon from "@material-ui/icons/Info";
import classnames from "classnames";
import React, { useState, useContext, useEffect } from "react";
import { Loading } from "../../components/Loading";
import { Query } from "../../lib/api/charts";
import { DashboardTabs } from "../DashboardTabs";
import { DashboardsConfig, DashboardConfig } from "../../lib/api/user";
import { DealerContext } from "../../contexts/DealerContext";
import { BrandContext } from "../../contexts/BrandContext";
import { UserContext } from "../../contexts/UserContext";
import { DashboardConfigContext } from "../../contexts/DashboardConfigContext";
import { ForecastContext } from "../../contexts/ForecastContext";
import { Select } from "../../components/Select";
import withWidth, { isWidthUp, WithWidth, WithWidthOptions, isWidthDown } from "@material-ui/core/withWidth";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import { Route } from "react-router-dom";
import { margin } from "../../style/theme";
import { OemContext } from "../../contexts/OemContext";
import { DateContext } from "../../contexts/FilterDateContext";
import { FilterBrandContext } from "../../contexts/FilterBrandContext";
import { BenchmarkContext } from "../../contexts/BenchmarkContext";
import { PeriodContext } from "../../contexts/PeriodContext";
import { BenchmarkSelection } from "../../Benchmark";
import { CustomDealerSelection } from "../dealer-selection/CustomDealer";
import { CustomDealerContext } from "../../contexts/CustomDealerContext";
import { isAfter, differenceInMonths, endOfMonth, subMonths } from "date-fns";
import { ExportButtons } from "../../components/ExportButtons";
import { DropdownDescription } from "../../lib/enum/dropdown-description";
import { translate, translation } from "../../translations/Translations";
import { useIntl } from "react-intl";
import { Breadcrumbs } from "../../components/Breadcrumbs";
import { PermissionsContext } from "../../contexts/PermissionsContext";
import { CommandPermissions } from "../../lib/api/permissions";
import { history } from "../../lib/history";
import { CurrencyContext } from "../../contexts/CurrencyContext";
import { Modal, Popover, Snackbar } from "@material-ui/core";
import { request } from "../../lib/api/base";
import { InfoRounded } from "@material-ui/icons";
import { RatesTable } from "../../components/RatesTable";
import { viewOptions } from "../../pages/custom/dealer/CustomInsight";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: "16px 32px 16px 32px",
      marginBottom: "50px",
      ["@media (max-width:1030px)"]: {
        padding: "16px",
      },
    },
    body: {
      gridArea: "body",
    },
    filterburger: {
      "@media(max-width: 900px)": {
        paddingTop: "6px",
        paddingBottom: "6px",
      },
      color: "#FFF",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      backgroundColor: "#191919",
    },
    filterButton: {
      cursor: "pointer",
      display: "flex",
      flexDirection: "row",
      fontSize: "14px",
      fontFamily:
        "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Helvetica, Arial, sans-serif",
      fontWeight: "bold",
    },
    filterText: {
      margin: theme.spacing.unit * 2,
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
    },
    placeHolderDiv: {
      width: "100%",
      margin: "auto",
      border: " none",
      maxWidth: "1300px",
      flexBasis: "50%",
    },
    burger: {
      marginTop: theme.spacing.unit * 2,
      marginBottom: theme.spacing.unit * 2,
      marginRight: theme.spacing.unit * 2,
      fontStyle: "bold",
      display: "flex",
      alignContent: "center",
      justifyContent: "center",
    },
    tabs: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
      gridArea: "tabs",
      borderTop: "none",
      maxWidth: margin.width,
      margin: "auto",
      backgroundColor: "#191919",
    },
    wrapper: {
      backgroundColor: "#191919",
    },
    benchmarkSelection: {
      gridColumn: "6/8",
      "@media(max-width: 1230px)": {
        gridColumn: "4/6",
      },
    },
    filters: {
      margin: "auto",
      gap: "1rem",
      display: "grid",
      gridTemplateColumns: "repeat( 7, 1fr )",
      "@media(max-width: 900px)": {
        display: "block",
      },
      alignContent: "center",
      [theme.breakpoints.up("md")]: {
        alignItems: "center",
      },
      gridArea: "filters",
      paddingLeft: "32px",
      paddingRight: "32px",
      // padding: "16px 32px 16px 32px",
      backgroundColor: "#191919",
      color: "#FFF",
      border: "none",
      maxWidth: margin.width,

      "@media (max-width: 1600px)": {
        paddingLeft: "32px",
        paddingRight: "32px",
      },
      paddingTop: "1rem",
      paddingBottom: "1rem",
    },
    chipWrapper: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
      alignItems: "center",
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "center",
      },
      gridArea: "filters",
      border: "none",
      maxWidth: margin.width,
      flexBasis: "50%",
    },
    searchInput: {
      "@media(max-width: 900px)": {
        marginBottom: "20px",
      },
      [theme.breakpoints.up("md")]: {
        width: "auto",
      },
      borderRadius: theme.shape.borderRadius,
      flex: "0 0 auto",
      fontSize: "12px",
      minWidth: "140px",
      height: "auto",
      color: "#333",
      fontWeight: "bold",
      zIndex: 100,
      // marginTop: theme.spacing.unit,
      fontFamily:
        "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Helvetica, Arial, sans-serif",
      marginRight: "0px",
    },
    dealerSearchInput: {
      "@media(max-width: 900px)": {
        marginBottom: "20px",
      },
      [theme.breakpoints.up("md")]: {
        width: "auto",
      },
      borderRadius: theme.shape.borderRadius,
      flex: "0 0 auto",
      fontSize: "12px",
      minWidth: "140px",
      height: "auto",
      color: "#333",
      fontWeight: "bold",
      zIndex: 200,
      // marginTop: theme.spacing.unit,
      fontFamily:
        "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Helvetica, Arial, sans-serif",
      marginRight: "0px",
    },
    smallerInput: {
      // minWidth: "160px",
    },
    mediumInput: {
      minWidth: "250px",
    },
    hideInput: {},
    menuWrapper: {
      background: "#191919",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "center",
      flexGrow: 1,
    },
    noFilter: {
      padding: theme.spacing.unit * 0.5,
    },
    chip: {
      margin: theme.spacing.unit,
    },
    exportBtn: {
      width: "100%",
      margin: "auto",
      border: "none",
      flexBasis: "50%",
    },
    exportBtnNoFlex: {
      width: "100%",
      margin: "auto",
      border: "none",
    },
    topBar: {
      display: "flex",
      justifyContent: "space-between",
      flexWrap: "wrap",
      maxWidth: margin.width,
      margin: "auto",
    },
    link: {
      color: "blue",
      cursor: "pointer",
    },
  });

export type DashboardOuterRenderProps = {
  query: Query;
  config: DashboardsConfig;
  updateConfig: (key: string, config: DashboardConfig) => void;
};

export type DashboardOuterProps = {
  department: string;
  meta?: any;
  hidePeriod?: boolean;
  onPerformanceAnalysisReport?: boolean;
  multipleBenchmarks?: boolean;
  render: (props: DashboardOuterRenderProps) => React.ReactNode;
  renderTabs?: (props: DashboardOuterRenderProps) => React.ReactNode;
  filters?: (props: DashboardOuterRenderProps) => React.ReactNode;
  hideBenchmark?: boolean;
  selectByTitlesOnly?: boolean;
  dealerTypes?: "consolidated" | "non-consolidated" | "all";
  submissionsTabs?: boolean;
  allowEmptyDealerInit?: boolean;
  title?: string;
  showAvgSelector?: boolean;
  submissions?: boolean;
  lockYtdAndBrand?: boolean;
} & WithStyles<typeof styles> &
  WithWidthOptions &
  WithWidth &
  React.HTMLAttributes<HTMLDivElement>;

export const formatFullDate = (date?: Date) => {
  const d = new Date(Date.parse(date.toString()));
  d.setDate(d.getDate() + 1);
  return d.toJSON();
};

const monthDict = {
  0: "January",
  1: "February",
  2: "March",
  3: "April",
  4: "May",
  5: "June",
  6: "July",
  7: "August",
  8: "September",
  9: "October",
  10: "November",
  11: "December",
};

export const formatDisplayDate = (date: Date = new Date()) => {
  return `${monthDict[date.getMonth()]} ${date.getFullYear()}`;
};

const months = (
  date = new Date(2015, 1, 1),
  end = new Date(),
  period: string,
  populated: { value: string; label: string }[] = [],
): { value: string; label: string }[] => {
  const d = new Date(Date.parse(date.toString()));
  if (period == "Quarterly") {
    if ([2, 5, 8, 11].includes(d.getMonth())) {
      populated.push({ value: formatFullDate(d), label: formatDisplayDate(d) });
    }

    if (d.getFullYear() == end.getFullYear() && d.getMonth() == end.getMonth()) {
      return populated;
    }

    d.setDate(1);
    d.setMonth(d.getMonth() + 1);

    return months(d, end, period, populated);
  }

  populated.push({ value: formatFullDate(d), label: formatDisplayDate(d) });

  if (d.getFullYear() == end.getFullYear() && d.getMonth() == end.getMonth()) {
    return populated;
  }

  d.setDate(1);
  d.setMonth(d.getMonth() + 1);

  return months(d, end, period, populated);
};

export const addMonths = (date: Date, years: number) => {
  const d = new Date(Date.parse(date.toJSON()));
  d.setMonth(d.getMonth() + years);
  return d;
};

type Option = { value: string; label: string };

const DashboardOuterUnstlyed: React.FunctionComponent<DashboardOuterProps> = ({
  classes,
  className,
  hidePeriod,
  renderTabs,
  department,
  render,
  meta,
  width,
  filters,
  hidden,
  onPerformanceAnalysisReport = false,
  multipleBenchmarks = true,
  hideBenchmark,
  dealerTypes,
  selectByTitlesOnly,
  submissionsTabs = false,
  allowEmptyDealerInit = false,
  showAvgSelector = false,
  title,
  submissions = false,
  lockYtdAndBrand = false,
}) => {
  const intl = useIntl();
  const dealer = useContext(DealerContext);
  const customDealer = useContext(CustomDealerContext);
  const { date, updateDate, financialMonth, financialMonthOptions, setFinancialMonth } = useContext(DateContext);
  const { brand, updateBrand } = useContext(FilterBrandContext);
  const brands = useContext(BrandContext);
  const configs = useContext(DashboardConfigContext);
  const targetCurrency = useContext(CurrencyContext);
  const forecasts = useContext(ForecastContext);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const oems = useContext(OemContext);
  const benchmark = useContext(BenchmarkContext);
  const { periods, selected: period, setPeriod } = useContext(PeriodContext);
  const { allowDashboardAvg, loading: permissionsLoading } = useContext(PermissionsContext);
  const [showBenchmarkChip, setShowBenchmarkChip] = useState(true);
  const { user, loading: userLoading } = useContext(UserContext);
  const { commandPermissions } = React.useContext(PermissionsContext);
  const canUpload: CommandPermissions[] = commandPermissions.filter(permission => permission.commandName === "UploadData");
  const { canExecute } = canUpload[0];
  const [snackOpen, setSnackOpen] = useState(false);
  const [ratesModalOpen, setRatesModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const currentOems = dealer.selected.oems;
  const { currencies } = targetCurrency;
  const formattedCurrencies = currencies.map(cur => ({
    label: intl.formatMessage({ id: translate(cur) }),
    value: cur,
  }));

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const availableBrands: Option[] = [
    {
      value: "",
      label: "All Brand",
    },
    ...(Object.values(
      Object.keys(brands.brands || {}).reduce((avail, code) => {
        const brand = brands.brands[code];
        if (customDealer.customSelected.brands.includes(code)) {
          avail[brand] = { value: code, label: brand };
        }
        return avail;
      }, {}),
    ) as Option[]),
  ];

  const [metadata, setMeta] = useState(meta || {});

  const allForecasts = forecasts.getForecasts();
  const availableForecasts = [
    // { label: "All Forecast", value: "" },
    ...(allForecasts || []).reduce((available, forecast) => {
      if (forecast.dealers.includes(customDealer.customSelected.code)) {
        available.push({ value: `${forecast.name}`, label: `${forecast.name} (${forecast.type})` });
      }
      return available;
    }, []),
  ];

  useEffect(() => {
    if (forecasts.loading.loaded && !availableForecasts.find(el => el.label === forecasts.selectedForecast.label)) {
      forecasts.setSelectedForecast(availableForecasts[0] || { value: "", label: "None" });
    }
  }, [customDealer.customSelected.code]);

  const query: Query = {
    date: date.value,
    department: department,
    dealers: dealer.selectedDealers,
    dealer: customDealer.customSelected,
    brand: brands.brands[brand.value],
    forecast: (allForecasts || []).find(forecast => forecast.name == forecasts.selectedForecast.value) || { name: "", type: "", dealers: [], measures: [] },
    benchmarks: benchmark.customSelected,
    period: period,
    meta: { ...metadata, selectedAgg: customDealer.selectedAgg },
    financialMonth: financialMonth,
    benchmarkDates: (benchmark.customSelected || [])
      .map(x => x.split(" - ")[0])
      .reduce((obj, key) => ({ ...obj, [key as any]: benchmark.benchmarkDates[key as any] }), {}),
    targetCurrency: targetCurrency.targetCurrency,
    currencyPeriod: "average",
  };

  useEffect(() => {
    targetCurrency.getCurrencies([...currentOems]);
    targetCurrency.getRates([customDealer.customSelected], query, benchmark.customSelected);
  }, [customDealer, targetCurrency.targetCurrency, targetCurrency.currencyPeriod]);

  if (!dealer.loading.loaded || !benchmark.loading.loaded || !configs.loading.loaded || !userLoading.loaded || !permissionsLoading.loaded) {
    return <Loading />;
  }

  const currencyPeriodOptions = [
    {
      label: intl.formatMessage({ id: translate("Close") }),
      value: "close",
    },
    {
      label: intl.formatMessage({ id: translate("Average") }),
      value: "average",
    },
  ];

  const hasForecast =
    customDealer.customSelected.hasTargets &&
    customDealer.customSelected.oems.find(oem => (oems.oems.find(o => o.code == oem) || { hasTargets: false }).hasTargets) &&
    availableForecasts.length > 0;

  const currencyOptions = [
    {
      label: intl.formatMessage({ id: translate("Base Currency") }),
      value: "",
    },
    ...formattedCurrencies,
  ];

  const userBrands = availableBrands.filter(brand => {
    if (user.usertype.toLocaleLowerCase() !== "o") {
      return true;
    }

    if (brand.value == "") {
      return true;
    }

    if (user.brands.length === 0) {
      return true;
    }

    return user.brands.includes(brand.value);
  });

  const noDataBms =
    benchmark.customSelected !== undefined &&
    benchmark.customSelected[0] != "" &&
    Object.keys(query.benchmarkDates)
      .filter(x => {
        const bmDate = endOfMonth(new Date(query.benchmarkDates[x].maxdate));
        return isAfter(endOfMonth(new Date(query.date)), bmDate) && differenceInMonths(endOfMonth(new Date(query.date)), bmDate) < 6;
      })
      .reduce((memo, val) => {
        const d = new Date(query.benchmarkDates[val].maxdate);
        memo[val] = {
          usedDate: `${monthDict[d.getMonth()]} ${d.getFullYear()}`,
        };
        return memo;
      }, {});

  const NewDealerText = () => {
    if (customDealer.customSelected.isConsolidated) {
      return <Typography variant="headline">This dealer has no data. This is a consolidated dealer so you cannot perform an upload.</Typography>;
    }

    if (customDealer.customSelected.isChildDealer) {
      return <Typography variant="headline">This dealer has no data. This is a child dealer so you cannot perform an upload.</Typography>;
    }

    return customDealer.customSelected.submissionsWorkbenchEnabled ? (
      <Typography variant="headline">
        This dealer has no data. You may begin the first upload{" "}
        <a className={classes.link} href={`/esos/${customDealer.customSelected.code}/submission/`}>
          here
        </a>
        .
      </Typography>
    ) : (
      <Typography variant="headline">
        This dealer has no data. You may begin the first upload{" "}
        <a className={classes.link} onClick={() => history.push("/submissions/submit")}>
          here
        </a>
        .
      </Typography>
    );
  };

  if (!customDealer.customSelected.dealer && !allowEmptyDealerInit) {
    return (
      <div style={{ margin: "auto", maxWidth: margin.width, padding: 5, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Typography variant="headline">
          There are no dealers for your selected filters please go update them <a href="/filters">here</a> and try to view this page again.
        </Typography>
      </div>
    );
  }
  if (!submissions && !customDealer.customSelected.isConsolidated && customDealer.customSelected.newDealer) {
    return (
      <>
        <div className={classnames(classes.wrapper, "joyride-filters")}>
          <Paper className={classes.filters}>
            <Route
              path="/:route/:dashboard?"
              render={({ match }) => {
                return (
                  <CustomDealerSelection
                    dashboardDealers={match.params.route == "oem" || (match.params.route == "reports" && /Network/.test(match.params.dashboard))}
                    className={classnames(classes.dealerSearchInput, "joyride-filters-dealer")}
                    onChange={() => {
                      updateBrand({ value: "", label: "All Brand" });
                      forecasts.setSelectedForecast({ value: "", label: "None" });
                    }}
                    dealerTypes={dealerTypes}
                  />
                );
              }}
            />
          </Paper>
        </div>
        <div style={{ margin: "auto", maxWidth: margin.width, padding: 5, display: "flex", alignItems: "center", justifyContent: "center" }}>
          {canExecute && <NewDealerText />}
        </div>
      </>
    );
  }

  const quarterlyMonth = () => {
    const selectedDate = subMonths(new Date(date.value), 1);

    let selectedMonth;
    if ([0, 1, 2].includes(selectedDate.getMonth())) {
      selectedMonth = 2;
    }
    if ([3, 4, 5].includes(selectedDate.getMonth())) {
      selectedMonth = 5;
    }
    if ([6, 7, 8].includes(selectedDate.getMonth())) {
      selectedMonth = 8;
    }
    if ([9, 10, 11].includes(selectedDate.getMonth())) {
      selectedMonth = 11;
    }

    return {
      value: formatFullDate(new Date(`${selectedDate.getFullYear()}-${selectedMonth + 1}-1`)).toString(),
      label: `${monthDict[selectedMonth]} ${selectedDate.getFullYear()}`,
    };
  };

  return (
    <>
      {!filtersOpen && isWidthDown("sm", width) && (
        <div className={classes.filterburger}>
          <div className={classes.filterButton}>
            <div className={classes.filterText}>Apply filters</div>
            <ExpandMore className={classes.burger} onClick={() => setFiltersOpen(true)} />
          </div>
        </div>
      )}
      {(filtersOpen || isWidthUp("md", width)) && (
        <div className={classnames(classes.wrapper, "joyride-filters")}>
          <Paper className={classes.filters}>
            <Route
              path="/:route/:dashboard?"
              render={({ match }) => {
                return (
                  <CustomDealerSelection
                    dashboardDealers={match.params.route == "oem" || (match.params.route == "reports" && /Network/.test(match.params.dashboard))}
                    className={classnames(classes.dealerSearchInput, "joyride-filters-dealer")}
                    onChange={() => {
                      updateBrand({ value: "", label: "All Brand" });
                      forecasts.setSelectedForecast({ value: "", label: "None" });
                    }}
                    dealerTypes={dealerTypes}
                  />
                );
              }}
            />
            {!hideBenchmark && benchmark.customSelected[0] && (
              <BenchmarkSelection
                dealers={[customDealer.customSelected]}
                setBenchmark={benchmark.setCustomBenchmark}
                benchmark={benchmark.customSelected}
                hidePeriods={hidePeriod}
                selectByTitlesOnly={selectByTitlesOnly}
                allowMultiple={multipleBenchmarks}
                className={classnames(classes.dealerSearchInput, classes.benchmarkSelection, classes.mediumInput)}
              />
            )}
            {/* {!hideBenchmark && benchmark.customSelected[0] && (
              <BenchmarkSelection
                dealers={[customDealer.customSelected]}
                setBenchmark={benchmark.setCustomBenchmark}
                benchmark={benchmark.customSelected}
                hidePeriods={hidePeriod}
                selectByTitlesOnly={selectByTitlesOnly}
                allowMultiple={multipleBenchmarks}
                className={classnames(classes.searchInput, classes.mediumInput, classes.class2)}
              />
            )} */}
            {!submissionsTabs && (
              <Select
                className={classnames(classes.searchInput, classes.smallerInput, classes.hideInput, "joyride-filters-brand")}
                value={brand.value == "" ? { value: brand.value, label: intl.formatMessage({ id: "all.brand.label" }) } : brand}
                defaultInputValue={""}
                placeholder="Brand"
                isDisabled={lockYtdAndBrand}
                onChange={(value: Option) => updateBrand(value)}
                options={[{ value: "disabled", label: DropdownDescription["BrandSelect"], isdisabled: true }, ...userBrands]}
              />
            )}
            {/* <BenchmarkSelection dealers={[dealer.customSelected]} hidePeriods={hidePeriod} className={classnames(classes.searchInput, classes.mediumInput)} /> */}
            {customDealer.customSelected.hasTargets &&
            customDealer.customSelected.oems.find(oem => (oems.oems.find(o => o.code == oem) || { hasTargets: false }).hasTargets) &&
            availableForecasts.length > 0 ? (
              <>
                <Select
                  className={classnames(classes.searchInput, classes.smallerInput, classes.hideInput, "joyride-filters-forecast")}
                  value={forecasts.selectedForecast}
                  defaultInputValue={""}
                  placeholder="Forecast"
                  onChange={(value: Option) => forecasts.setSelectedForecast(value)}
                  options={[
                    { value: "disabled", label: DropdownDescription["ForecastSelect"], isdisabled: true },
                    { value: "", label: "None" },
                    ...availableForecasts,
                  ]}
                />
                {!onPerformanceAnalysisReport && (
                  <Select
                    className={classnames(classes.searchInput, classes.smallerInput, "joyride-filters-period")}
                    value={{ value: period, label: intl.formatMessage({ id: translation[period] }) }}
                    onChange={value => setPeriod(value.value)}
                    options={[
                      { value: "disabled", label: DropdownDescription["PeriodSelect"], isdisabled: true },
                      ...periods.map(opt => ({ value: opt, label: intl.formatMessage({ id: translation[opt] }) })),
                    ]}
                  />
                )}
                {!onPerformanceAnalysisReport && period == "Financial Year" && (
                  <Select
                    className={classnames(classes.searchInput, classes.smallerInput, "joyride-filters-financialMonth")}
                    value={{ value: financialMonth, label: monthDict[financialMonth] }}
                    onChange={value => setFinancialMonth(value.value)}
                    options={[
                      { value: "disabled", label: DropdownDescription["FinancialMonthSelect"], isdisabled: true },
                      ...financialMonthOptions.map(opt => ({ value: opt, label: monthDict[opt] })),
                    ]}
                  />
                )}
                <Select
                  className={classnames(classes.searchInput, classes.smallerInput, "joyride-filters-month")}
                  value={date}
                  onChange={value => updateDate(value as any)}
                  options={[
                    { value: "disabled", label: DropdownDescription["MonthSelect"], isdisabled: true },
                    ...months(customDealer.customSelected.minMonth, customDealer.customSelected.maxMonth, period).reverse(),
                  ]}
                />
                {filters && filters({ query, config: configs.configs, updateConfig: configs.updateConfig })}
                {isWidthDown("sm", width) && <ExpandLess className={classes.burger} onClick={() => setFiltersOpen(false)} />}
              </>
            ) : (
              <>
                {!hidePeriod && !onPerformanceAnalysisReport && !submissionsTabs && (
                  <Select
                    MenuProps={{ style: { zIndex: 50000 } }}
                    className={classnames(classes.searchInput, classes.smallerInput, "joyride-filters-period")}
                    value={{ value: period, label: intl.formatMessage({ id: translation[period] }) }}
                    onChange={value => {
                      setPeriod(value.value);
                      if (value.value == "Quarterly") {
                        updateDate(quarterlyMonth());
                      }
                    }}
                    isDisabled={lockYtdAndBrand}
                    options={[
                      { value: "disabled", label: DropdownDescription["PeriodSelect"], isdisabled: true },
                      ...periods.map(opt => ({ value: opt, label: intl.formatMessage({ id: translation[opt] }) })),
                    ]}
                  />
                )}
                {!hidePeriod && !onPerformanceAnalysisReport && !submissionsTabs && period == "Financial Year" && (
                  <Select
                    className={classnames(classes.searchInput, classes.smallerInput, "joyride-filters-financialMonth")}
                    value={{ value: financialMonth, label: monthDict[financialMonth] }}
                    onChange={value => setFinancialMonth(value.value)}
                    options={[
                      { value: "disabled", label: DropdownDescription["FinancialMonthSelect"], isdisabled: true },
                      ...financialMonthOptions.map(opt => ({ value: opt, label: monthDict[opt] })),
                    ]}
                  />
                )}
                <Select
                  className={classnames(classes.searchInput, classes.smallerInput, "joyride-filters-month")}
                  value={date}
                  onChange={value => updateDate(value as any)}
                  options={[
                    { value: "disabled", label: DropdownDescription["MonthSelect"], isdisabled: true },
                    ...months(customDealer.customSelected.minMonth, customDealer.customSelected.maxMonth, period).reverse(),
                  ]}
                />
                {filters && filters({ query, config: configs.configs, updateConfig: configs.updateConfig })}
                {isWidthDown("sm", width) && <ExpandLess className={classes.burger} onClick={() => setFiltersOpen(false)} />}
              </>
            )}

            <Select
              className={classnames(classes.searchInput, classes.smallerInput, "joyride-filters-month")}
              value={currencyOptions.length > 1 ? currencyOptions.filter(cur => targetCurrency.targetCurrency === cur.value) : currencyOptions[0]}
              onChange={async value => {
                const isDateAvailableQuery = await request("/currency/availability", {
                  method: "POST",
                  body: JSON.stringify({ query: query }),
                });
                const isDateAvailableResult = await isDateAvailableQuery.json();
                if (!isDateAvailableResult.data.isAvailable) {
                  setSnackOpen(true);
                  return;
                }
                targetCurrency.updateTargetCurrency(value.value);
              }}
              options={currencyOptions}
            />

            {!!customDealer.customSelected.dealer && showAvgSelector ? (
              <>
                <div>
                  <Select
                    className={classnames(classes.searchInput, classes.smallerInput, "joyride-filters-month")}
                    value={customDealer.selectedAgg == "avg" ? { value: "avg", label: "Average by Dealer Count" } : { value: undefined, label: "Default" }}
                    onChange={value => customDealer.setSelectedAgg(value.value)}
                    options={[{ value: undefined, label: "Default" }, { value: "avg", label: "Average by Dealer Count" }, ,]}
                  />
                </div>
              </>
            ) : (
              <div className={classes.placeHolderDiv} />
            )}
          </Paper>
          {!!customDealer.customSelected.dealer && <DashboardTabs dealer={customDealer.customSelected} className={classes.tabs} />}
          {renderTabs && renderTabs({ query, config: configs.configs, updateConfig: configs.updateConfig })}
        </div>
      )}
      {!!customDealer.customSelected.dealer ? (
        <div className={classnames(classes.root, className, "here")}>
          <div className={classes.topBar}>
            <div>
              <Breadcrumbs />
              <ExportButtons
                className={noDataBms && Object.keys(noDataBms).length > 0 && showBenchmarkChip ? classes.exportBtn : classes.exportBtnNoFlex}
                title={title || department}
                id={"custom-metrics"}
                filters={{
                  dealer: customDealer.customSelected.dealer,
                  brand: brand.label,
                  date: date.label,
                  forecast: forecasts.selectedForecast.label,
                  period: period,
                  benchmarks: benchmark.customSelected,
                  financialMonth: monthDict[financialMonth],
                  currency: targetCurrency.targetCurrency ? targetCurrency.targetCurrency : customDealer.customSelected.currency,
                  view: viewOptions[query.meta.selectedAgg],
                }}
              />
            </div>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-end" }}>
              {noDataBms && Object.keys(noDataBms).length > 0 && showBenchmarkChip ? (
                <div className={classes.chipWrapper}>
                  <Chip
                    icon={<InfoIcon />}
                    variant="outlined"
                    style={{ marginLeft: "auto" }}
                    color="primary"
                    label={`${Object.keys(noDataBms)
                      .map(x => `${x}: ${noDataBms[x].usedDate}`)
                      .join(" | ")}`}
                    onDelete={() => setShowBenchmarkChip(!showBenchmarkChip)}
                    className={classes.chip}
                  />
                </div>
              ) : (
                <div className={classes.placeHolderDiv} />
              )}
            </div>
          </div>
          {render({ query, config: configs.configs, updateConfig: configs.updateConfig })}
        </div>
      ) : (
        <div style={{ margin: "auto", maxWidth: margin.width, padding: 5, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Typography variant="headline">Please select a dealer.</Typography>
        </div>
      )}
      <Snackbar
        style={{ marginTop: "1rem" }}
        open={snackOpen}
        onClose={() => setSnackOpen(false)}
        autoHideDuration={5000}
        message="Conversion rate not available for the selected time period"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      />
      <Modal
        open={ratesModalOpen}
        onClose={() => setRatesModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableAutoFocus
      >
        <RatesTable onClose={() => setRatesModalOpen(false)} />
      </Modal>
    </>
  );
};

export const CustomDashboardOuter = withStyles(styles)(withWidth()(DashboardOuterUnstlyed));
